import { render, staticRenderFns } from "./chemReviewPop.vue?vue&type=template&id=0f4dbc70"
import script from "./chemReviewPop.vue?vue&type=script&lang=js"
export * from "./chemReviewPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4dbc70')) {
      api.createRecord('0f4dbc70', component.options)
    } else {
      api.reload('0f4dbc70', component.options)
    }
    module.hot.accept("./chemReviewPop.vue?vue&type=template&id=0f4dbc70", function () {
      api.rerender('0f4dbc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewPop.vue"
export default component.exports